import { render } from "./NewDonorDeclarationFormMobile.vue?vue&type=template&id=12bace08&scoped=true"
import script from "./NewDonorDeclarationFormMobile.vue?vue&type=script&lang=js"
export * from "./NewDonorDeclarationFormMobile.vue?vue&type=script&lang=js"

import "./NewDonorDeclarationFormMobile.vue?vue&type=style&index=0&id=12bace08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bace08"]])

export default __exports__